const AuthLayout = () => import(/* webpackChunkName: "auth" */'../../layouts/AuthLayout');
const LoginPage = () => import(/* webpackChunkName: "auth" */'../../pages/auth/LoginPage');
const ForgotPasswordPage = () => import(/* webpackChunkName: "auth" */'../../pages/auth/ForgotPasswordPage');
const ResetPasswordPage = () => import(/* webpackChunkName: "auth" */'../../pages/auth/ResetPasswordPage');

/* eslint-disable */
export default {
    path: '/auth',
    name: 'auth',
    redirect: { name: 'login' },
    component:  AuthLayout,
    children: [
        {
            path: 'login',
            name: 'login',
            component: LoginPage,
        },
        {
            path: 'forgot',
            name: 'forgot',
            component: ForgotPasswordPage,
        },
        {
            path: 'reset/:hash',
            name: 'reset',
            component: ResetPasswordPage,
        },
    ],
};
